module.exports = __webpack_public_path__ + "images/37bd78990d6df8aaedd6d92b12bc0211.svg";